import { defineComponent as r, openBlock as t, createBlock as c, Transition as s, withCtx as i, createElementBlock as l, normalizeClass as a, createElementVNode as o, toDisplayString as d, createCommentVNode as n } from "vue";
import { E as u } from "./props.types-D8SW9rH8.js";
import { _ as f } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const m = {
  key: 0,
  class: "zg-loader__text"
}, g = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "25 25 50 50",
  class: "zg-loader__circles"
}, x = ["r"], z = ["r"], y = /* @__PURE__ */ r({
  __name: "ZgLoader",
  props: {
    /**
      * Boxed version
    */
    boxed: {
      type: Boolean,
      default: !1
    },
    /**
      * When used in a button
    */
    button: {
      type: Boolean,
      default: !1
    },
    /**
      * Text shown with the loader
    */
    text: {
      type: String,
      default: null
    },
    /**
      * Make fullscreen
    */
    fullscreen: {
      type: Boolean,
      default: !1
    },
    /**
      * small, medium or large affects radius and stroke width.
    */
    size: {
      type: String,
      default: "large",
      validator: (e) => u.includes(e)
    }
  },
  setup(e) {
    return (_, b) => (t(), c(s, { name: "fade" }, {
      default: i(() => [
        e.size ? (t(), l("div", {
          key: 0,
          class: a(["zg-loader", {
            "zg-loader--boxed": e.boxed && e.fullscreen,
            "zg-loader--fullscreen": e.fullscreen,
            "zg-loader--button": e.button
          }])
        }, [
          o("div", {
            class: a([
              "zg-loader__box",
              `zg-loader--${e.size}`
            ])
          }, [
            e.text ? (t(), l("p", m, d(e.text), 1)) : n("", !0),
            (t(), l("svg", g, [
              o("circle", {
                cx: "50",
                cy: "50",
                r: e.button ? 21 : 23,
                fill: "none",
                "stroke-miterlimit": "10"
              }, null, 8, x),
              o("circle", {
                class: "circle-animation",
                cx: "50",
                cy: "50",
                r: e.button ? 21 : 23,
                fill: "none",
                "stroke-miterlimit": "10"
              }, null, 8, z)
            ]))
          ], 2)
        ], 2)) : n("", !0)
      ]),
      _: 1
    }));
  }
}), v = /* @__PURE__ */ f(y, [["__scopeId", "data-v-5720c37a"]]);
export {
  v as default
};
//# sourceMappingURL=ZgLoader-CUlZYwAv.js.map
